interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'center' | 'left';
  accentWord?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'center',
  accentWord,
}: SectionHeadingProps) {
  return (
    <div className={`${align === 'center' ? 'text-center' : 'text-left'}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
        <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
        {title}
        {accentWord ? <span className="text-primary-500"> {accentWord}</span> : null}
      </h2>
      {desc ? (
        <p
          className={`mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-700 ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}